<template>
  <!--电子数据保全证书-详情-->
  <div class="certi-page">
    <el-row>
      <el-col :span="10" :offset="2">
        <div style="text-align: center; margin: 20px 0">
          证书编号：{{ this.presId }}
        </div>
        <div class="img-certi">
          <a
            :href="certUrl"
            target="_blank"
            title="点击放大"
            v-if="certStatus"
            v-loading="certLoading"
            style="min-height: 637px; display: inline-block; width: 100%"
          >
            <img
              :src="certUrl"
              @loadstart="certLoading = true"
              @load="certLoading = false"
            />
          </a>
          <a
            href="javascript:void(0);"
            @click="flushCertStatus($route.query)"
            title="点击刷新"
            v-else
            v-loading="certLoading"
            style="min-height: 637px; display: inline-block"
          >
            <img
              :src="certUrl"
              @loadstart="certLoading = true"
              @load="certLoading = false"
            />
          </a>
        </div>
      </el-col>
      <el-col :span="10" :offset="2">
        <div class="div-certification">
          <!-- 24-07-31 产品告知隐藏 -->
          <h6 style="font-weight: bold" v-if="false">
            区块链存证查询
            <span
              style="
                color: rgba(0, 0, 0, 0.45);
                font-size: 12px;
                font-weight: 500;
              "
              >/ 提示：请先复制证书编号，再进入查询</span
            >
          </h6>
          <div class="btn-box" v-if="false">
            <el-button
              @click="toPath('http://iacg.aihuz.com/', '_blank')"
              size="small"
              class="btn"
              >赣国仲裁委</el-button
            >
            <el-button
              @click="toPath('http://swzcw.aihuz.com/', '_blank')"
              size="small"
              class="btn"
              >深汕仲裁委</el-button
            >
            <el-button
              @click="toPath('http://syac.aihuz.com/', '_blank')"
              size="small"
              class="btn"
              >十堰仲裁委</el-button
            >
            <el-button
              @click="
                toPath(
                  'http://cngzc.sfj.taiyuan.gov.cn/web/index.html#/chain',
                  '_blank'
                )
              "
              size="small"
              class="btn"
              style="margin-left: 0; margin-top: 20px"
              >城南公证处</el-button
            >
            <!--<el-button @click="toPath('http://www.wasfjd.org.cn/index', '_blank')" size="small" class="btn">司法鉴定查询 </el-button>-->
          </div>
          <h6 style="font-weight: bold">存证证书下载</h6>
          <div class="btn-box">
            <el-button @click="downloadCert(1)" size="small" class="btn"
              >下载JPG证书</el-button
            >
            <el-button @click="downloadCert(2)" size="small" class="btn"
              >下载PDF证书</el-button
            >
          </div>
          <h6 style="font-weight: bold">法律服务申请</h6>
          <!-- 1019需求优化按钮和申请入口-->
          <!-- <div class="btn-box">
            <el-button @click="redirectTesity('cqgzc')" size="small" class="btn">申请公证证书</el-button>
            <el-button v-if="!($store.getters.currentAuthUser || {}).corpUserId" @click="redirectTesity('sfjdzx')" size="small" class="btn">申请保管函</el-button>
          </div>-->
          <div class="btn-box">
            <!-- <el-button @click="redirectTesity('ebaoquan')" size="small" class="btn">申请E证据包</el-button>-->
            <el-button @click="redirectTesity('')" size="small" class="btn"
              >申请出证</el-button
            >
              <!-- 24-07-31 产品告知隐藏 -->
            <div class="dropdown" v-if="false">
              <p class="title">
                在线申请仲裁<i class="el-icon-caret-bottom color-danger"></i>
              </p>
              <ul class="dropdown-menu">
                <li @click="redirectTesity('arbitration')">广州仲裁委</li>
                <li @click="toZHArb">珠海仲裁委</li>
              </ul>
            </div>
          </div>
          <div class="btn-box" v-if="false">
            <el-button
              @click="showFqgzDialog = true"
              size="small"
              class="btn"
              v-if="fqgzStatus.fqgzFlag"
              >赋强公证</el-button
            >
            <el-button @click="redirectTesity('sjw')" size="small" class="btn"
              >申请债权变现</el-button
            >
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      :visible.sync="showFqgzDialog"
      title="赋强公证出证"
      width="550px"
      :close-on-click-modal="false"
    >
      <div>
        <template v-if="fqgzStatus.jkrFlag">
          <h6>法律服务</h6>
          <div style="margin-top: 10px; margin-bottom: 20px">
            <el-button
              @click="redirectTesity('fqgzs')"
              size="small"
              type="danger"
              class="btn"
              >公证书</el-button
            >
            <el-button
              v-if="fqgzStatus.fqzxsFlag"
              @click="redirectTesity('fqzxs')"
              type="danger"
              size="small"
              class="btn"
              >执行书</el-button
            >
            <el-button v-else size="small" class="btn" disabled
              >执行书</el-button
            >
          </div>
          <h6>温馨提示：</h6>
          <div class="margin-bottom-lg text-left" style="margin-top: 10px">
            办理赋强公证的流程是：签署时申请>获取受理函>申请公证书>申请执行证书，如果您需要申请执行证书的话，请务必先取得公证书，否则无法申请。
          </div>
        </template>
        <template v-else>
          <h6>特别提示：</h6>
          <div class="margin-bottom-lg text-left">
            借出方已为该合同申请了赋强公证，公证处已受理。如逾期不还款，借出方有权直接向公证处申请强制执行书，并通过法院强制执行债务追回。为了您的良好征信记录，请积极履约，按时还款。
          </div>
        </template>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: center; margin-top: 40px"
      >
        <el-button
          @click="showFqgzDialog = false"
          size="small"
          type="danger"
          style="width: 120px"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ApiMethods } from '@/assets/js/http-serve/http-methods';
import { isInDingTalk } from '../../assets/js/utils/ding-env';

export default {
  methods: {
    patchToZero: function (perId) {
      let len = 10 - (perId ? perId.toString().length : 0)
      for (let i = 0; i < len; i++) {
        perId = "0" + perId;
      }
      return perId;
    },
    toPath: function (url, target) {
      window.open(url, target)
    },
    downloadCert: function (type) {
      let param = this.$route.query;
      param.downType = type;

      window.location.href = ApiMethods.CertiController.downCerti_url(param)
      //ApiMethods.CertiController.downCerti_down(param);
    },
    flushCertStatus: function () {
      let param = this.$route.query;
      ApiMethods.CertiController.certiStatus(param).then(result => {
        this.certStatus = result.success && result.data;
        if (result.success && !result.data) {
          this.$confirm('证书努力生成中，请稍候再试', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton: false
          }).then(() => {
          }).catch(() => {
          });
        } else if (result.success && result.data) {
          location.reload();
        }

      })
    },
    loadFqgzSttaus: function () {
      var _this = this;
      var param = this.$route.query;
      ApiMethods.CertiController.certiFqgz(param).then(result => {
        if (result.success) {
          _this.fqgzStatus = result.data;
        }
      })
    },
    redirectTesity: function (code) {
      var _this = this, param = this.$route.query;
      param.code = code;
      ApiMethods.CertiController.redirectTesity(param).then(result => {
        if (result.success) {
          isInDingTalk ? location.href = result.data : window.open(result.data,'_self');
        } else {
          _this.$message.error(result.description || this.$tip)
          // if (!isInDingTalk) ow.close();
        }
      }).catch(err => {
        // ow.close();
      });
    },
    toZHArb () {
      const url = this.globalConfig.domain.arbitrationUrl + '/arbitration/zh/step1.html';
      isInDingTalk ? location.href = url : window.open(url, "_blank")
    },
    fetchData: function () {
      this.loadFqgzSttaus();
    },
  },
  created () {
    this.presId = this.patchToZero(this.$route.query.presId);
    this.certUrl = this.apiMethods.CertiController.showCerti_url(this.$route.query);
    ApiMethods.CertiController.certiStatus(this.$route.query).then(result => {
      this.certStatus = result.success && result.data;
    });
    this.fetchData();
  },
  data () {
    return {
      apiMethods: ApiMethods,
      certLoading: true,
      certStatus: false,
      fqgzStatus: { fqgzFlag: false, jkrFlag: false, fqzxsFlag: false },
      showFqgzDialog: false,
      certUrl: '',
      presId: "",
    }
  },
  name: "certiPage",
  head: { title: '法律服务' }
}
</script>

<style lang="less" scoped>
.dropdown {
  display: inline-block;
  position: relative;
  margin-left: 10px;
  width: 120px;
  text-align: center;
  p.title {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    padding: 9px 0px;
    font-size: 12px;
    border-radius: 3px;
    width: 120px;

    i {
      margin-left: 4px;
    }
  }

  p.title:hover {
    color: #ec1c1c;
    border-color: #ec1c1c;
  }

  .dropdown-menu {
    display: none;
    width: 120px;
    border: 1px solid #ec1c1c;
    border-bottom: 0;
    border-radius: 3px;
    position: absolute;

    li {
      padding: 5px 0;
      border-bottom: 1px solid #ec1c1c;
      cursor: pointer;
    }
    li:hover {
      color: #ffffff;
      background: #ec1c1c;
    }
  }
}
.dropdown:hover .dropdown-menu,
.dropdown-menu:hover {
  display: block;
}

.div-certification {
  padding: 40px 0;

  .btn-box {
    margin-bottom: 20px;
  }

  .btn {
    width: 120px;
    margin-right: 30px;
  }

  h6 {
    margin-top: 80px;
    font-size: 12px;
    margin-bottom: 10px;
    font-weight: 500;
    line-height: 1.1;
  }
}

.img-certi {
  text-align: center;

  img {
    width: 90%;
  }
}
.certi-page {
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 30px 0;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// pages/certi/certiPage.vue